import React from 'react';
import './index.css';
import { Link } from 'react-router-dom';

const VillaError = () => {
  return (
    <div className="villa-error-container">
      <div className="wave-background"></div>
      <div className="wave-backgroundtop"></div>
      <div className="villa-error-content">
        <i className="fas fa-umbrella-beach"></i>
        <h1>404 Error</h1>
        <h2>Lost in Paradise?</h2>
        <p>The page you're looking for seems to have vanished into the sunset.</p>
        <Link to="/">
          <button className="villa-error-button">Back to Home</button>
        </Link>
      </div>
    </div>
  );
};

export default VillaError;